import gaTracker from './gaTracker';

export default () => gaTracker('clientId');
